import { teamMembers } from "@/mocks/team";

export default function TeamSection() {
  const featured = teamMembers.filter((m) => m.featured);
  const engineers = teamMembers.filter((m) => !m.featured && m.title.includes("Mühendis"));
  const others = teamMembers.filter((m) => !m.featured && !m.title.includes("Mühendis"));

  return (
    <section id="ekip" className="bg-white py-24 px-6">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="text-[#4CAF50] text-sm font-semibold uppercase tracking-widest mb-2 block">
            Kadromuz
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-[#1A2B4A] mb-3">
            Uzman Ekibimiz
          </h2>
          <p className="text-[#718096] text-base max-w-md mx-auto">
            Deneyimli mühendis ve formen kadromuzla her projede en yüksek kaliteyi sunuyoruz.
          </p>
        </div>

        {/* Featured Row */}
        <div className="flex flex-col sm:flex-row gap-6 justify-center mb-6">
          {featured.map((member) => (
            <TeamCard key={member.id} member={member} large />
          ))}
        </div>

        {/* Engineers Row */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-6">
          {engineers.map((member) => (
            <TeamCard key={member.id} member={member} />
          ))}
        </div>

        {/* Others Row */}
        <div className="flex flex-col sm:flex-row gap-6 justify-center">
          {others.map((member) => (
            <TeamCard key={member.id} member={member} />
          ))}
        </div>
      </div>
    </section>
  );
}

interface Member {
  id: number;
  name: string;
  title: string;
  image: string;
  linkedin: string;
}

function TeamCard({ member, large = false }: { member: Member; large?: boolean }) {
  return (
    <div
      className={`bg-[#F8F9FA] rounded-2xl overflow-hidden flex flex-col items-center text-center p-8 hover:-translate-y-1.5 hover:shadow-md transition-all duration-300 group ${
        large ? "sm:w-72" : "w-full"
      }`}
    >
      {/* Photo */}
      <div className="relative mb-5">
        <div className="w-28 h-28 rounded-full overflow-hidden border-2 border-[#4CAF50]/40 group-hover:border-[#4CAF50] transition-colors duration-300">
          <img
            src={member.image}
            alt={member.name}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          />
        </div>
        {large && (
          <div className="absolute -bottom-1 -right-1 w-6 h-6 flex items-center justify-center bg-[#4CAF50] rounded-full">
            <i className="ri-star-fill text-white text-xs" />
          </div>
        )}
      </div>

      {/* Info */}
      <h3 className="text-[#1A2B4A] font-bold text-base mb-1">{member.name}</h3>
      <p className="text-[#4CAF50] text-sm font-semibold mb-4">{member.title}</p>

      {/* LinkedIn */}
      {member.linkedin !== "#" && (
        <a
          href={member.linkedin}
          target="_blank"
          rel="noopener noreferrer"
          className="w-8 h-8 flex items-center justify-center rounded-full bg-white border border-gray-200 text-[#718096] hover:text-[#0077B5] hover:border-[#0077B5] transition-colors duration-200 cursor-pointer"
          aria-label={`${member.name} LinkedIn`}
        >
          <i className="ri-linkedin-line text-sm" />
        </a>
      )}
    </div>
  );
}
